import { ContentProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import { EditorialFlexModule } from "../../../../../../typings/microserviceModels/content-flex-module";
import CardComparisonSectionEditorial from "./CardComparisonSectionEditorial";
import CardComparisonImageSectionEditorial from "./CardComparisonImageSectionEditorial";
import CardComparisonFeatureSectionEditorial from "./CardComparisonFeatureSectionEditorial";
import CardComparisonBenefitsSectionEditorial from "./CardComparisonBenefitsSectionEditorial";
import CardComparisonBenefitsTitleEditorial from "./CardComparisonBenefitsTitleEditorial";
import CardComparisonBenefitsEditorial from "./CardComparisonBenefitsEditorial";
import CardComparisonNoFeeBenefitsEditorial from "./CardComparisonNoFeeBenefitsEditorial";
import CardComparisonAddedBenefitsSectionEditorial from "./CardComparisonAddedBenefitsSectionEditorial";
import CardComparisonAddedBenefitsEditorial from "./CardComparisonAddedBenefitsEditorial";
import CardComparisonNoFeeAddedBenefitsEditorial from "./CardComparisonNoFeeAddedBenefitsEditorial";
import CardComparisonMobileApplyNowEditorial from "./CardComparisonMobileApplyNowEditorial";

export const CardComparisonSection = (props: ContentProps) => {
  const model: EditorialFlexModule = props.flexComponent.model as EditorialFlexModule;

  return (
    <div>
      {model.title.includes("fee_title") && (
        <CardComparisonSectionEditorial flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
      )}
      {model.title.includes("image_section") && (
        <CardComparisonImageSectionEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
      {model.title.includes("grid_section") && (
        <CardComparisonFeatureSectionEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
      {model.title.includes("benefits_title") && (
        <CardComparisonBenefitsSectionEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
      {model.title.includes("benefits_heading") && (
        <CardComparisonBenefitsTitleEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
      {model.title.includes("fee_benefits") && (
        <CardComparisonBenefitsEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
      {model.title.includes("nofees_benefits") && (
        <CardComparisonNoFeeBenefitsEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
      {model.title.includes("added_benefitss_heading") && (
        <CardComparisonAddedBenefitsSectionEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
      {model.title.includes("nofee_added_benefits") && (
        <CardComparisonNoFeeAddedBenefitsEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
      {model.title.includes("addeds_benefits") && (
        <CardComparisonAddedBenefitsEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
      {model.title.includes("mobile_applynow") && (
        <CardComparisonMobileApplyNowEditorial
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
    </div>
  );
};

export default CardComparisonSection;
